import { Box, Container, Grid, Typography } from "@mui/material"
import { useApi } from "auth/useApi3"
import ContactInfoCard from "components/ContactInfoCard/ContactInfoCard"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { SkeletonCard } from "components/skeleton/SkeletonCard"
import { SkeletonCardImage } from "components/skeleton/SkeletonCardImage"
import { apiEndpoints } from "generated/apiEndpoints"
import React from "react"
import { useTranslation } from "react-i18next"
import { ExaminationInfoCard } from "./components/ExaminationInfoCard/ExaminationInfoCard"

const LearningDashboard = () => {
  const { t } = useTranslation()
  const translationAssigned = t("learning.admin.overview.assigned", { returnObjects: true })

  const loadingContext = React.useContext(GlobalLoaderContext)

  const [assignedExams, assignedExamsFuncs] = useApi()
  const [passedExamsResult, passedExamsFuncs] = useApi()
  const [managerResult, managerFuncs] = useApi()

  React.useEffect(() => {
    assignedExamsFuncs.get(apiEndpoints.learning.getassignedexaminations)
    passedExamsFuncs.get(apiEndpoints.learning.getpassedresultsshortlist)
    managerFuncs.get(apiEndpoints.learning.getmanager)
    return () => {
      assignedExamsFuncs.leave()
      passedExamsFuncs.leave()
      managerFuncs.leave()
    }
  }, [assignedExamsFuncs, passedExamsFuncs, managerFuncs])

  React.useEffect(() => {
    loadingContext.setLoading(() => assignedExams.status === 1)
  })
  React.useEffect(() => {
    loadingContext.setLoading(() => passedExamsResult.status === 1)
  })

  return (
    <Container>
      <Grid item>
        <Typography variant="h2" mb={5}>
          {t("learning.titles.my_courses", "My courses")}
        </Typography>
      </Grid>
      <Grid container direction="row" spacing={5}>
        <Grid item xs={12} md={12} lg={8}>
          <Grid container direction="row" spacing={3}>
            {assignedExams.status === 2 &&
              assignedExams.data.map((item, key) => {
                let assignedCourse = Array.isArray(translationAssigned)
                  ? translationAssigned.find((course) => course.examinationType === item.examinationType)
                  : null

                return (
                  <Grid item xs={12} key={key}>
                    <ExaminationInfoCard assignedCourse={assignedCourse} item={item} showDescription={true} />
                  </Grid>
                )
              })}
          </Grid>

          {assignedExams.status === 1 && (
            <Grid container direction="row" spacing={3} marginTop={1}>
              {Array.from(new Array(2)).map((item) => (
                <Grid item xs={12} key={item}>
                  <SkeletonCardImage />
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
        <Grid item md={12} xs={12} lg={4}>
          {managerResult.status === 2 && managerResult.data !== null && managerResult.data !== "" && (
            <>
              <ContactInfoCard data={managerResult.data} />
            </>
          )}
          {managerResult.status === 1 && (
            <Box marginTop={6}>
              <SkeletonCard />
            </Box>
          )}
        </Grid>
      </Grid>
    </Container>
  )
}
export default LearningDashboard
